import { NotifyModel, NotifyModelProps } from '@mail/3promo';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { truthy } from '@mail-core/std/fn/validate/truthy';
import { IS_NEW_PROMO_FD_PARAMS, NEW_PROMO_FD_PARAMS } from 'reactApp/appHelpers/featuresHelpers/features/3promoFakeDoor';
import { UniversalFakeDoorPromo } from 'reactApp/modules/promoNew/components/UniversalPromo/UniversalFakeDoorPromo';
import type { FakeDoorPreloadingImages, FakeDoorTemplateData } from 'reactApp/modules/promoNew/types';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { store as reduxStore } from 'reactApp/store';

export const getFakeDoorCreator =
    (id: string, templateData: FakeDoorTemplateData, preloadingImages: FakeDoorPreloadingImages): ModelCreator =>
    ({ models, render, stores }) =>
        new NotifyModel(
            id,
            { ...models.base, ...models.notify },
            new NotifyModelProps(id, {
                store: new LocalStorageStore(id, stores.localStorage),
                renderer: new ReactRenderer(id, UniversalFakeDoorPromo, render.react),
                closable: true,
                templateData,
                preloadingImages,
                hideOnCompleted: false,
                test(resolve, reject) {
                    // не показываем, если открыт просмотрщик файлов
                    const state = reduxStore.getState();
                    const isViewerActive = ViewerSelectors.isViewerActive(state);

                    if (isViewerActive) {
                        reject();
                    } else {
                        resolve();
                    }
                },
            })
        );

export const composeFakeDoorCreator = (): ModelCreator | undefined => {
    if (!IS_NEW_PROMO_FD_PARAMS) {
        return;
    }

    const { id, title = '', text, button, imageLight, imageDark } = NEW_PROMO_FD_PARAMS;

    const staticImgLightTheme = imageLight ? imageLight : undefined;
    const staticImgDarkThemeTheme = imageDark ? imageDark : undefined;
    const preloadingImages = [staticImgLightTheme, staticImgDarkThemeTheme].filter(truthy);

    return getFakeDoorCreator(
        id,
        {
            title,
            text,
            buttons: {
                complete: button,
            },
            image: staticImgLightTheme
                ? {
                      light: staticImgLightTheme,
                      dark: staticImgDarkThemeTheme ? staticImgDarkThemeTheme : undefined,
                  }
                : undefined,
        },
        preloadingImages
    );
};
